import { createReducer } from "reduxsauce";

import { INITIAL_STATE } from "./initialState";
import { StoreTypes } from "./actions";

export const setSelectedStore = (state, { data }) => {
  return {
    ...state,
    selectedStore: data,
  };
};

export const setMerchant = (state, { merchant }) => {
  return {
    ...state,
    merchant,
  };
};

export const setStores = (state, { stores }) => {
  return {
    ...state,
    stores,
  };
};

export const setStockTypes = (state, { stockTypes }) => {
  return {
    ...state,
    stockTypes,
  };
};

export const reducer = createReducer(INITIAL_STATE, {
  [StoreTypes.SET_SELECTED_STORE]: setSelectedStore,
  [StoreTypes.SET_MERCHANT]: setMerchant,
  [StoreTypes.SET_STORES]: setStores,
  [StoreTypes.SET_STOCK_TYPES]: setStockTypes,
});
